import { View, Text, StyleSheet, ScrollView } from "react-native";
import React from "react";

const TermsOfService = () => {
	return (
		<View style={styles.root}>
			<ScrollView style={styles.container}>
				<View style={styles.section}>
					<Text style={styles.title}>
						I. SOBRE NÓS E NOSSA INTENÇÃO COM ESTA POLÍTICA
					</Text>
					<Text style={styles.description}>
						1. Agradecemos o seu interesse na ISIC - Carteirinha do Estudante
						(CME SERVICOS PROCESSAMENTO ELETRÔNICO DE DADOS LTDA) (“Nós”,
						“Nosso” e suas variações, “CME” ou “ISIC”). A nossa missão é
						desenvolver um trabalho de apoio a melhorias Interculturais,
						aumentando oportunidades educacionais e facilitando a vida do
						estudante ao redor do mundo por meio da única identidade estudantil
						reconhecida no mundo todo: a ISIC.
						{"\n"}
						2. Em todo nosso processo, entendemos que a proteção de seus dados
						pessoais e da sua privacidade é algo muito importante e, para
						estabelecer uma relação de confiança e transparência com Você,
						elaboramos este documento (“Política de Privacidade” ou “Política”),
						destinado a Você - nosso cliente, fornecedor ou prestador de
						serviço. Nesta Política, Você encontrará maiores informações a
						respeito da forma de coleta e tratamento de seus dados pessoais, bem
						como sobre quais são os seus direitos como titular de dados pessoais
						e como exercê-los, em observância à legislação aplicável,
						especialmente à Lei n° 13.709/2018 (Lei Geral de Proteção de Dados -
						"LGPD").
						{"\n"} 3. Esta Política se aplica às informações que Você nos
						fornece e que podemos obter de Você, por meio (i) do nosso website,
						telefones de contato, fale conosco, páginas de redes sociais e de
						quaisquer outras páginas ou sites associados ao uso e à promoção dos
						nossos produtos e serviços; (ii) do aplicativo ISIC para
						dispositivos móveis; ou (iii) coleta presencial em Lojas STB ou por
						parceiros (“Serviços”). Assim, qualquer pessoa que acesse ou use o
						Serviços de qualquer forma será considerada um Usuário ("Você",
						"Seu" ou "Usuário") e está ciente de que suas informações são
						coletadas, usadas e transferidas conforme estabelecido nesta
						Política. Leia-a com atenção antes de acessar ou usar o nosso
						Serviço. Boa leitura!
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						II. DADOS COLETADOS E MOTIVOS DA COLETA{" "}
					</Text>
					<Text style={styles.description}>
						4. Para que possamos fornecer adequadamente nossos Serviços e
						produtos, incluindo o seu acesso ao nosso site, podemos coletar os
						seguintes dados pessoais para as seguintes finalidades, os quais
						serão armazenados em nossos sistemas ou em sistemas contratados:{" "}
						{"\n"}➢ Dados Pessoais fornecidos por você quando há interesse em
						conhecer e contratar nossos Serviços: a CME pode tratar informações
						recebidas de você a partir dos nossos canais de contato com a CME
						por website, aplicativo, atendimento presencial ou empresas
						parceiras. Dessa forma, podemos coletar os seguintes dados para o
						fornecimento de nossos Serviços:{"\n"} (i) cadastro e emissão da
						carteirinha: nome, CPF, e-mail, data de nascimento, telefone, dados
						de cartão de crédito ou bancários, dados de pagamento, número de
						matrícula/comprovante de vínculo estudantil ou comprovante
						empregatício, curso, data de nascimento, foto 3x4, gênero; {"\n"}
						(ii) canal “fale conosco” para dúvidas, “Seja um distribuidor ISIC”
						e “Seja nosso parceiro”: nome, email, telefone, estado, cidade e
						CPF; {"\n"}(iii) coleta de dados por meio de aplicativos fornecidos
						através de parceiros: nome, CPF, e-mail, data de nascimento,
						telefone, dados de cartão de crédito ou bancários, dados de
						pagamento, número de matrícula/comprovante de vínculo estudantil ou
						comprovante empregatício, curso data de nascimento, foto 3x4;{"\n"}{" "}
						(iv) clube de benefícios: código da carteira. Esses dados são
						coletados para abertura de atendimento, prosseguimento e
						fornecimento da emissão da carteira, candidatura em processo
						seletivo para ser distribuidor ou parceiro ISIC, manutenção do Seu
						cadastro em nossas bases e operacionalização/fornecimento de nossos
						produtos através das nossas parcerias, obtenção de descontos e
						benefícios e outros. Ao optar pela emissão da carteira ISIC através
						de nossos parceiros, você entende que estes dados deverão ser
						compartilhados entre as partes envolvidas (parceiro e ISIC) para
						fins de cumprimento contratual.{"\n"} ➢ Dados de fornecedores e
						prestadores de serviço: a CME pode coletar dados de fornecedores,
						parceiros e seus sócios como nome, telefone, RG e CPF, e-mail,
						estado civil endereço (todos presentes nos atos constitutivos) e
						dados de CNPJ dos parceiros. Esses dados são coletados somente
						quando necessários para desenvolvimento de produtos, parcerias,
						prestação de serviços para a CME, elaboração de contratos, avaliar
						as documentações regulatórias aplicáveis, emitir a nota fiscal e
						garantir a relação de confiança entre as partes.{"\n"} ➢ Dados de
						uso e navegação na plataforma: coletamos informações sobre as
						operações e atividades realizadas através do seu uso de nosso
						website, como datas, duração e frequência das sessões do Usuário do
						nosso AV. BRIG. FARIA LIMA 1713 | 16º ANDAR | JD. PAULISTANO | SÃO
						PAULO | 01452-915 CARTEIRINHAISIC | MINHAISIC | website e acesso por
						qualquer meio ao serviço e geolocalização do dispositivo, tablets ou
						computadores por meio dos quais o serviço é acessado e utilizado;
						endereço de IP da conexão, data, horário, duração e frequência do
						acesso à Plataforma e informações gerais. Também poderemos utilizar
						certas ferramentas, próprias ou de terceiros, para monitoramento das
						atividades realizadas enquanto você acessa o nosso site, tais como
						Cookies e ferramentas de analytics e performance. Mais informações
						sobre Cookies e tecnologias semelhantes utilizadas no site
						encontram-se logo abaixo.{"\n"} ➢ Dados tratados para o cumprimento
						de obrigação legal ou regulatória: podemos coletar e compartilhar
						dados para cumprimento de obrigações legais ou regulatórias
						específicas, decorrentes dos Serviços oferecidos pela CME, tais como
						o compartilhamento de dados estudantis com Poder Público para
						cumprimento da Lei nº 12.933/2013 (Lei da Meia Entrada), FESN
						(Federação dos Estudantes Nacional) para geração de autenticação
						digital e ITI (Instituto Nacional de Tecnologia da Informação).{" "}
						{"\n"}➢ Dados tratados para exercício regular de direitos pela CME
						em processos judiciais, administrativos ou arbitrais: podemos tratar
						dados pessoais para que possamos analisar e comprovar fatos e
						questões sob a perspectiva jurídica, de modo a atuar e instruir
						demandas judiciais, administrativas ou arbitrais das quais a CME
						figure como parte ou, de alguma forma, seja parte interessada, bem
						como quando necessário para responder, de boa-fé, a ordens judiciais
						ou demais intimações encaminhadas por órgãos competentes. Dessa
						forma, podemos manter o cadastro do cliente por certo período em
						nossa base de dados. III. TERCEIROS COM QUEM PODEMOS COMPARTILHAR
						SEUS DADOS PESSOAIS
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						III. TERCEIROS COM QUEM PODEMOS COMPARTILHAR SEUS DADOS PESSOAIS
					</Text>
					<Text style={styles.description}>
						5. Podemos compartilhar os Seus dados pessoais com terceiros, dentro
						dos limites da legislação aplicável. São eles:{"\n"}• PRESTADORES DE
						SERVIÇOS E FORNECEDORES para a realização e prestação de serviços
						relacionados ao cumprimento do contrato entre Nós e nossos clientes,
						atendimento ao cliente, acesso ao escritório e outros.{"\n"}•
						PARCEIROS para desenvolvimento dos produtos, estabelecer parcerias
						comerciais e cumprimento com o contrato firmado com você ou com
						nossos parceiros.{"\n"}• ÓRGÃOS PÚBLICOS para cumprimento de
						obrigações legais ou regulatórias e ordens proferidas por
						autoridades públicas competentes, bem como para atendimento de
						solicitações judiciais, administrativas ou arbitrais. {"\n"}•
						EMPRESAS DO MESMO GRUPO ECONÔMICO quando necessário para cumprimento
						das finalidades apresentadas nesta Política de Privacidade e em
						linha com o que contratado por você no uso de nossos Serviços.{"\n"}
						• INSTITUIÇÕES FINANCEIRAS para a realização de pagamento de
						fornecedores, prestadores de serviços e parceiros e realizar a
						gestão financeira da CME.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						IV. FORMA DE ARMAZENAMENTO DE SEUS DADOS PESSOAIS E PERÍODO
					</Text>
					<Text style={styles.description}>
						6. Todos os dados tratados pela CME são armazenados em servidores
						próprios da CME ou por nós contratados e consistem em sistemas
						seguros, observando as exigências estabelecidas pela legislação
						vigente, e com base na implementação e atualização constantes das
						melhores práticas do mercado em termos de segurança e privacidade,
						garantindo a integridade e proteção dos Seus dados pessoais. Assim,
						implementamos tecnologias e medidas internas por meio de controle de
						acessos, controle de Firewall dos servidores internos e externos,
						uso de API's para requisições de sistemas e outros, a fim de
						resguardar seus dados pessoais contra acessos não autorizados e uso
						indevido. AV. BRIG. FARIA LIMA 1713 | 16º ANDAR | JD. PAULISTANO |
						SÃO PAULO | 01452-915 CARTEIRINHAISIC | MINHAISIC |{"\n"}
						7. Para além das medidas acima, tratamos o Seu dado pessoal somente
						pelo período necessário às finalidades para as quais foram
						realizadas as coletas. Mais especificamente, poderemos manter seus
						dados pessoais enquanto viger nossa relação comercial, contratual ou
						jurídica de forma geral ou para cumprimento de obrigação legal,
						regulatória ou para o nosso exercício regular de direitos em
						processo judicial, administrativo ou arbitral, tendo como limites de
						guarda os prazos prescricionais e decadenciais aplicáveis.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						V. TRANSFERÊNCIA INTERNACIONAL DE DADOS
					</Text>
					<Text style={styles.description}>
						8. Para fins de fornecimento das carteirinhas ISIC, a CME deverá
						compartilhar internacionalmente seus dados pessoais com a ISIC
						Internacional, com o fim de cumprimento do contrato estabelecido
						entre a CME e Você e para validação da carteirinha ISIC. Ressalta-se
						que a CME busca sempre observar o mesmo nível de proteção
						resguardada pela LGPD em suas parcerias, garantindo o alto nível de
						segurança no armazenamento das informações e no intuito de
						estabelecer contratos que respeitem os termos desta Política de
						Privacidade e a legislação de proteção de dados pessoais aplicável.
						Ao concordar com essa Política, Você declara estar ciente de que o
						tratamento dos Seus dados pessoais também poderá ocorrer fora do
						território nacional.{"\n"}
						9. Nas demais ocasiões, e sempre que pertinente, a CME pode coletar
						seu consentimento específico e em destaque para a transferência, com
						informação prévia sobre o caráter internacional da operação e
						ressaltando esta finalidade das demais finalidades de tratamento
						existentes. 10. Os Seus dados pessoais também poderão ser
						armazenados em servidores localizados{"\n"}
						fora do território nacional, incluindo, mas não se restringindo, a
						servidores de computação em nuvem que seguem padrões internacionais
						de tratamento e segurança de dados pessoais. Dessa forma, Você
						compreende que tais dados poderão ser tratados pelo Parceiro de
						acordo com suas próprias políticas de privacidade.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>VI. COOKIES E FINALIDADES</Text>
					<Text style={styles.description}>
						11. Cookies são um recurso padrão das plataformas que permitem
						armazenar pequenas quantidades de dados em seu computador ou
						dispositivo móvel a respeito da sua visita à plataforma. Você pode
						optar por aceitar o uso de Cookies e tecnologias semelhantes de duas
						formas: (i) aceitando ou rejeitando a coleta de Cookies não
						essenciais através do centro de configuração de Cookie que a CME
						coloca à sua disposição, ao qual pode aparecer através da mensagem
						de informação básica sobre Cookies que aparece quando visita o
						website pela primeira vez; ou (ii) em geral, alterando as
						configurações do seu navegador que podem ser encontradas no site do
						seu provedor de Internet por meio da tela de ajuda, ou por meio dos
						seguintes links: Chrome; Firefox; Microsoft Edge; Internet Explorer.
						No entanto, se Você os desativar, sua experiência no site poderá ser
						reduzida e alguns recursos poderão não funcionar conforme o
						esperado. {"\n"}● Cookies e tecnologias semelhantes que podemos
						utilizar em nosso site quanto à sua finalidade {"\n"}12. A seguir,
						indicamos os diferentes tipos de Cookies e tecnologias semelhantes
						que poderão ser utilizados por nós: {"\n"}➢ Cookies essenciais:
						esses Cookies permitem a você navegar pelo site, bem como utilizar
						suas funcionalidades. Sem esses Cookies, o site não desempenhará o
						quanto pretendido, podendo até não ser possível a utilização de
						determinadas funcionalidades. Esse tipo de cookies também pode obter
						informações sobre a navegação para que se possa personalizar a
						experiência do Usuário. {"\n"}➢ Cookies de preferência: os Cookies
						de preferência coletam informações sobre suas escolhas e
						preferências, e permitem à CME lembrar o idioma e outras
						configurações locais, além de personalizar o site de acordo com suas
						preferências. {"\n"}➢ Cookies analíticos: estes Cookies coletam
						informações para gerar relatórios que indicam quais são as páginas
						mais visitadas na plataforma, o tempo gasto e os links clicados nas
						páginas. Isso permite à CME ver os padrões gerais de uso do site.
						Essas informações são utilizadas apenas para analisar o tráfego da
						plataforma, e não para identificar informações individuais sobre
						você. {"\n"}➢ Cookies de marketing/publicidade: Estes Cookies podem
						ser estabelecidos através do nosso site pelos nossos parceiros de
						publicidade. Podem ser usados por certas empresas para construir um
						perfil sobre os seus interesses e mostrar-lhe anúncios relevantes em
						outros websites. Eles não armazenam diretamente AV. BRIG. FARIA LIMA
						1713 | 16º ANDAR | JD. PAULISTANO | SÃO PAULO | 01452-915
						CARTEIRINHAISIC | MINHAISIC | informações pessoais, mas são baseados
						na identificação exclusiva do seu navegador e dispositivo de
						internet. Se você não permitir estes Cookies, terá menos publicidade
						direcionada. {"\n"}➢ Informações do navegador ou do dispositivo:
						certas informações são coletadas pela maioria dos navegadores ou
						automaticamente pelo dispositivo, como endereço MAC (Media Access
						Control), tipo de computador (Windows ou Mac), resolução de tela,
						nome e versão do sistema operacional, fabricante e modelo do
						dispositivo, idioma, tipo e versão do navegador da Internet que Você
						está usando. Poderemos utilizar essas informações para garantir que
						a plataforma funcione corretamente.{"\n"} Tipos de Cookies próprios
						ou de terceiros {"\n"}➢ Cookies de proprietários: aqueles que são
						enviados para o seu dispositivo a partir do website gerido pela CME.{" "}
						{"\n"}➢ Cookies de terceiros: aqueles que são enviados para o seu
						dispositivo a partir de um computador e/ou domínio que não é gerido
						pela CME, mas por terceiro que realiza o tratamento dos dados
						obtidos através dos Cookies para os seus próprios fins. {"\n"}Tipos
						de Cookies de acordo com o período de tempo em que permanecem
						ativados no seu dispositivo {"\n"}➢ Cookies de Sessão: são os
						concebidos para recolher e armazenar informações apenas durante toda
						a sua visita ao website, e desaparecem no final da sessão.
						Utilizados para armazenar informações que só está interessado em
						manter, a fim de garantir as funcionalidades básicas do website
						durante a visita. {"\n"}➢ Cookies Persistentes:são aqueles em que as
						informações obtidas continuam a ser armazenadas no dispositivo e
						expiram dentro de um período superior à duração da sua visita ao
						website. Este período é definido pelo responsável pelo Cookie e
						varia de acordo com cada tipo de Cookie.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						VII. SEUS DIREITOS EM RELAÇÃO AO PROCESSAMENTO DE SEUS DADOS
						PESSOAIS
					</Text>
					<Text style={styles.description}>
						13. Você poderá exercer seus direitos referentes ao processamento de
						seus dados pessoais conforme estabelecido pela LGPD, aos quais devem
						ser solicitados de forma expressa por você (titular dos dados
						pessoais) ou por seu representante legal, devendo ser comprovada a
						sua titularidade. Conheça os Seus direitos: Direito à informação
						(Art. 9 e 18, VII e VIII da LGPD) Você tem o direito de ser
						informado sobre: (i) a finalidade, a forma e a duração do
						tratamento; (ii) a identificação e as informações de contato da CME;
						(iii) as informações acerca do compartilhamento dos Seus dados com
						entidades públicas e privadas, a finalidade desse compartilhamento e
						as responsabilidades dos agentes de tratamento envolvidos; (iv) como
						exercer outros direitos previstos na Lei, como os direitos do art.
						18 da LGPD; (v) consequências sobre o não fornecimento de seus dados
						pessoais, aos quais, em alguns casos, poderá acarretar na
						impossibilidade de dar prosseguimento no fornecimento da carteira
						ISIC. Direito de confirmação ao tratamento e direito de acesso (Art.
						18, I e II da LGPD) Você poderá confirmar se tratamos seus dados
						pessoais, assim como poderá solicitar acesso a essas informações.
						Direito à retificação dos seus dados (Art. 18, III da LGPD); Você
						pode requisitar a correção de seus dados incompletos, inexatos ou
						desatualizados na base de dados da CME. Quando os dados retificados
						forem compartilhados com terceiros, a CME fará esforços para
						informá-los a respeito da necessidade de atualização (art. 18, §
						6º). Direito à anonimização, ao bloqueio, à eliminação de dados
						desnecessários (Art. 18, IV da LGPD) e à oposição (Art. 18, § 2º da
						LGPD); Quando os dados pessoais tratados forem desnecessários,
						excessivos ou tratados em desconformidade com esta Política ou com a
						legislação aplicável, você poderá nos solicitar, caso aplicável: (i)
						a anonimização de seus dados; (ii) o bloqueio de seus dados
						pessoais; (iii) a eliminação de seus dados pessoais; ou (iv) a
						oposição ao tratamento, mesmo que tais dados sejam tratados mediante
						outra base legal que não o consentimento. É importante que seu
						pedido indique as razões pelas quais Você entende que seus dados
						estão sendo tratados em desconformidade com a legislação de proteção
						de dados pessoais para que possamos retornar à Você com informações
						e respostas mais precisas a respeito dos fatos questionados. Nesses
						casos, registraremos o Seu pedido e caso seja verificada e
						diagnosticada alguma dessas hipóteses, a CME se compromete a excluir
						os dados questionados. Caso não seja possível verificar qualquer
						irregularidade, informaremos a você e procuraremos resolver
						eventuais dúvidas. Direito de revogação do consentimento e
						eliminação dos dados pessoais tratados com o consentimento do
						titular (Art. 18, VI e IX da LGPD); É possível que Você, de forma
						livre e a qualquer momento, revogue seu consentimento a determinado
						tratamento de dados mediante manifestação expressa, gratuita e
						facilitada, sempre que esta for a base legal utilizada na atividade
						de tratamento. Direito de portabilidade (Art. 18, V, da LGPD) Você
						poderá requerer que seu dado seja transmitido para outras empresas,
						a depender do Seu interesse, desde que não viole a propriedade
						intelectual ou segredo de negócios da CME. Informamos, contudo, que
						mais esclarecimentos sobre a implementação e concretização deste
						direito estão pendentes de regulamentação pela Autoridade Nacional
						de Proteção de Dados - ANPD. 14. A CME buscará cumprir com
						celeridade todas as solicitações enviadas pelos titulares para o
						canal protecaodedados@isic.com.br, desde que aplicáveis ao caso em
						questão. Em alguns casos, é possível que haja motivos legítimos para
						que a CME deixe de atender a uma solicitação em razão da existência
						de obrigação de reter dados, como, por exemplo, para cumprir
						obrigações legais ou regulatórias, ou para possibilitar a defesa da
						CME ou de terceiros em disputas de qualquer natureza. Informaremos a
						você a respeito e procuraremos resolver eventuais dúvidas. Conte com
						a gente!
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						VIII. TRATAMENTO DE DADOS DE CRIANÇAS E ADOLESCENTES
					</Text>
					<Text style={styles.description}>
						15. Para cumprimento e divulgação de nossos produtos, podemos tratar
						dados pessoais de crianças e adolescentes para fins de fornecimento
						da Carteira de Estudante ISIC e da carteira ISIC Internacional. A
						CME se compromete a realizar todos os melhores esforços para
						verificar a validade da solicitação da carteira, consideradas as
						tecnologias disponíveis, e sempre agirá no melhor interesse da
						criança e do adolescente, nos termos do Estatuto da Criança e do
						Adolescente e em respeito ao regime de capacidade civil previsto no
						Código Civil. 16. Também respeitamos a coleta do consentimento
						parental ou de responsável legal previsto na LGPD sempre que essa
						for a base legal aplicável às nossas operações.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>
						IX. ALTERAÇÕES NA POLÍTICA E DISPOSIÇÕES GERAIS
					</Text>
					<Text style={styles.description}>
						17. Poderemos alterar esta Política de Privacidade a qualquer tempo,
						visto que buscamos sempre melhorar e aprimorar nossos Serviços. Em
						caso de alterações, disponibilizaremos nossa nova Política a todos
						os Usuários em nosso site. AV. BRIG. FARIA LIMA 1713 | 16º ANDAR |
						JD. PAULISTANO | SÃO PAULO | 01452-915 CARTEIRINHAISIC | MINHAISIC |
						18. Em caso de dúvidas sobre esta Política, entre em contato conosco
						por meio do e-mail protecaodedados@isic.com.br.
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.title}>X. LEI COMPETENTE E FORO APLICÁVEL</Text>
					<Text style={styles.description}>
						19. Esta Política de Privacidade é regida pela legislação do Brasil.
						Qualquer litígio relacionado ao site, à Política de Privacidade ou
						ao seu conteúdo deverá ser submetido ao Foro da Comarca de São Paulo
						- SP, excetuando-se os casos em que houver previsão legal em
						contrário.
					</Text>
				</View>
				<Text style={styles.description}>
					Versão 2.0{"\n"}
					Última modificação desta Política: 11 de outubro de 2022
				</Text>
			</ScrollView>
		</View>
	);
};

export default TermsOfService;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
		paddingHorizontal: 20,
		paddingVertical: 26,
	},
	container: {
		paddingBottom: 10,
	},
	title: {
		fontWeight: "600",
		fontSize: 18,
		marginBottom: 4,
		color: "#2D2D2D",
	},
	description: {
		fontSize: 16,
		color: "#999999",
		lineHeight: 22,
	},
	section: {
		marginBottom: 16,
	},
});
